// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2g53I","productName":"Table_productName__34MW-"};